import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // flex 布局库

import 'flex.css'; // 组件

import '@/components'; // svg 图标

import '@/assets/svg-icons'; // 国际化

import _i18n from '@/i18n.js'; // 功能插件

import pluginApi from '@/plugin/api';
import pluginError from '@/plugin/error';
import pluginLog from '@/plugin/log';
import pluginOpen from '@/plugin/open';
export default {
  install: function install(Vue, options) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 设置为 false 以阻止 vue 在启动时生成生产提示
              // https://cn.vuejs.org/v2/api/#productionTip
              Vue.config.productionTip = false; // 当前环境

              Vue.prototype.$env = process.env.NODE_ENV; // 当前的 baseUrl

              Vue.prototype.$baseUrl = process.env.BASE_URL; // 当前版本

              Vue.prototype.$version = process.env.VUE_APP_VERSION; // 构建时间

              Vue.prototype.$buildTime = process.env.VUE_APP_BUILD_TIME; // Element

              Vue.use(ElementUI, {
                i18n: function i18n(key, value) {
                  return _i18n.t(key, value);
                }
              }); // 插件

              Vue.use(pluginApi);
              Vue.use(pluginError);
              Vue.use(pluginLog);
              Vue.use(pluginOpen);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};